// @owners { team: patients }
import { SIZES } from '@alto/design-library-tokens';
import { SizedImage } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { getImageAltText } from '~shared/assets/images/getImageAltText';

export const PhoneImage = () => {
  return (
    <SizedImage
      source={getImage('phone')}
      accessibilityLabel={getImageAltText('phone')}
      pixelSize={SIZES.ILLUSTRATION.LG.value}
    />
  );
};
